import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';
import { Row, Col, Tab, Nav, Badge, Tooltip, OverlayTrigger } from "react-bootstrap";
import LightGallery from 'lightgallery/react';
// import styles
import 'lightgallery/css/lightgallery.css';
import axios from 'axios';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import rice_img from '../../../../images/raw_material/rice.png';
import tomoto from '../../../../images/raw_material/tomato.png';
import dhal from '../../../../images/raw_material/dhal.png';
import black_sesame_img from '../../../../images/raw_material/black_sesame.png';
import documents from '../../../../images/doc.png';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { create } from '@mui/material/styles/createTransitions';


const ViewCorporateOrder = () => {
 
  const tableRef = useRef(null);
  const [addOnService, setAddOnService] = useState({});
  const [mealsPeriod, setMealsPeriod] = useState([]);
  const BaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [vendors, setVendors] = useState();
  const [payments, setPayments] = useState([]);
  const [gst_percentage, setGstPercentage] = useState(0);

  const fetchitemSchedule = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);

      const list = response.data?.data;

      if (Array.isArray(list)) {
        const formatted = list.map(item => ({
          value: String(item.sno),
          label: item.itemschedule_name
        }));
        setMealsPeriod(formatted);
      } else {
        setMealsPeriod([]); // fallback to empty array
      }
    } catch (error) {
      console.error('Failed to fetch Meals period:', error);
      setMealsPeriod([]); // fallback to empty array, not object
    }
  };
 
  const getMealsPeriodLabel = (sno) => {
    if (!Array.isArray(mealsPeriod)) return '';
    const found = mealsPeriod.find(mp => mp.value === String(sno));
    return found?.label || '';
  };

  const getOrderStatus = (status) => {
    const map = {
      "0": { label: "Order Pending", bgColor: "#f3bc59", textColor: "#000" },
      "1": { label: "Ordered", bgColor: "#f3bc59", textColor: "#000" },
      "2": { label: "Order Confirmed", bgColor: "#90ee90", textColor: "#000" },
      "3": { label: "Order Postponed", bgColor: "#3399ff", textColor: "#fff" },
      "4": { label: "Order Cancelled", bgColor: "#f44336", textColor: "#fff" },
      "5": { label: "Payment Pending", bgColor: "#8a2be2", textColor: "#fff" },
      "6": { label: "Out For Delivery", bgColor: "#00008b", textColor: "#fff" },
      "7": { label: "Delivered", bgColor: "#006400", textColor: "#fff" },
      "8": { label: "Paid", bgColor: "#006400", textColor: "#fff" },
      "9": { label: "Refund Initiated", bgColor: "#fff700", textColor: "black" },
      "10": { label: "Refunded", bgColor: "#536ae3", textColor: "white" },
    };

    return map[status] || { label: "Unknown", bgColor: "#ccc", textColor: "#000" };
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

  const fetchVendors = async (branch_id) => {
    try {
      const response = await axios.get(`${BaseUrl}/manage_corporate_order/get_vendors/${branch_id}`);

      if (response.data?.data) {
        // Map the data to the required format
        const formattedVendors = response.data.data.map(vendor => ({
          value: vendor.sno.toString(),             // or vendor.vendor_id if you want unique string id
          label: vendor.vendor_businessname || 'Unknown Vendor',
        }));

        setVendors(formattedVendors);
        console.log('Formatted Vendors:', formattedVendors);
      } else {
        console.error('No vendors found for this branch ID');
        toast.error('Not Able to Fetch Vendors');
        setVendors([]);
      }
    } catch (error) {
      console.error('Error fetching vendors:', error);
      setVendors([]);
    }
  };

  const getVendorLabel = (vendorId) => {
    if (!vendorId) return null;                   // no vendor id, no label
    if (!Array.isArray(vendors)) return vendorId; // vendors not ready yet, return raw id

    const found = vendors.find(v => v.value === vendorId.toString());
    return found ? found.label : vendorId;       // fallback if not found
  };

  const fetchAddOnService = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/addonservice/getactive`);
      if (response.data && Array.isArray(response.data)) {
        const formatted = response.data.map(item => ({
          value: String(item.sno),
          label: item.service,
          vendor: item.vendor,
          cost_per_unit: item.cost_per_unit,
        }));
        setAddOnService(formatted);
      }
    } catch (error) {
      console.error('Failed to Add On Service Type:', error);
      setAddOnService({});
    }
  };

  const getServiceName = (serviceId) => {
    if (!serviceId || !Array.isArray(addOnService)) return serviceId;
    const found = addOnService.find(s => s.value === serviceId.toString());
    return found ? found.label : serviceId;
  };

  const getGST = () => {
    axios.get(`${BaseUrl}/generalSetting/1`)
      .then(response => {
        if (response.data && response.data.data) {
          setGstPercentage(parseFloat(response.data.data.gst));
        } else {
          console.log("Unexpected API response structure:", response);
          setGstPercentage(5);
        }
      })
      .catch(error => {
        console.log("Failed to fetch general settings:", error);
        setGstPercentage(5);
      });
  }

  useEffect(() => {
    fetchitemSchedule();
    fetchVendors(branch_id);
    fetchAddOnService();
    getGST();
  }, []);

  useEffect(() => {
    const tables = document.querySelectorAll('.subscription_table');
    tables.forEach((table) => {
      if (!$.fn.dataTable.isDataTable(table)) {
        $(table).DataTable({
          "responsive": true,
          "ordering": false,
          "language": {
            "lengthMenu": "Show _MENU_",
          },
          "dom":
            "<'row'" +
            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
            ">" +
            "<'table-responsive'tr>" +
            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
            ">"
        });
      }
    });
  }, []);

  const styles = {
    ul: {
      listStyleType: 'none',
      // paddingLeft: '0.5rem',
      position: 'relative',
    },
    li: {
      position: 'relative',
      paddingLeft: '1.5rem',
      marginBottom: '1rem',
    },
    bullet: {
      content: '">"',
      position: 'absolute',
      left: '0',
      top: '0',
      color: '#fd310dff', // Bootstrap primary color
      fontSize: '1rem',
      lineHeight: '1.5',
    },
  };

  const location = useLocation();
  const order = location.state?.order;
  useEffect(() => {
    fetchPaymentlist();
  }, []);

  const fetchPaymentlist = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/manage_corporate_order/payment_list_by_order/${order.id}`);
      if (response.data && response.data.success) {
        setPayments(response.data.data);
      } else {
        console.error('No payment data found for this order');
        setPayments([]);
      }
    } catch (error) {
      console.error('Error fetching payment data:', error);
      setPayments(null);
    }
  };

  if (!order) return <p>No order data found</p>;

  const orderDate = order.order_date || '-';  // from order_date

  const customerInfo = {
    customer_name: order.customer?.customer_name || '-',
    customer_number: order.customer?.customer_number || '-',
    customer_email: order.customer?.customer_email || '-',
    company_name: order.customer?.company_name || '-',
    company_number: order.customer?.company_number || '-',
  };

  const headCount = order.head_count || 0;   // from head_count

  const parseJSONSafe = (data) => {
    if (!data) return [];
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (e) {
        console.error("Failed to parse JSON:", e);
        return [];
      }
    }
    if (Array.isArray(data)) return data;
    return [];
  };

  const items = parseJSONSafe(order.items);

  // const items = order.items ? JSON.parse(order.items) : [];

  const raw = order.addonservice;
  let addOns = [];

  if (raw && raw !== "null") {
    try {
      addOns = typeof raw === "string" ? JSON.parse(raw) : raw;
    } catch (e) {
      console.error("Parse error:", e);
    }
  } else {
    addOns = [];
  }

  addOns = Array.from(addOns);

  const mappedAddOns = Array.isArray(addOns) ? addOns.map(({ service, vendor, quantity, totalCost }) => ({
    name: getServiceName(service),                  // get service name by ID
    vendor: vendor ? getVendorLabel(vendor) : null, // vendor label logic as before
    units: quantity,
    costPerUnit: quantity && totalCost ? (totalCost / quantity).toFixed(2) : '0.00',
    totalCost,
  })) : [];

  const cateringIdDisplay = typeof order.catering_id === 'object' ? JSON.stringify(order.catering_id) : order.catering_id;

  const orderStatus = getOrderStatus(order.order_status);

  const specialRequest = order.special_request || '-';

  const orderPostponedDate = order.order_postpone_date || '-';

  const orderPostponedCancelledReason =
    order.order_postpone_reason
      ? `Postpone: ${order.order_postpone_reason}`
      : '';

  const cancellationReason =
    order.cancellation_reason
      ? `${order.cancellation_reason}`
      : '';

  const combinedReason =
    orderPostponedCancelledReason && cancellationReason
      ? `${orderPostponedCancelledReason} | ${cancellationReason}`
      : orderPostponedCancelledReason || cancellationReason || '-';

  const totalCost = order.total || '0';  // from total

  return (

    <>
      <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
        <div className="mb-0">
          <div className="mb-0 px-0">
            <h4 className="breadcrumb-header">View Corporate Order</h4>
          </div>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item">
              <i className="fa-solid fa-angles-right fs-8"></i>
            </li>
            <li className="breadcrumb-item">Corporate Management</li>
            <li className="breadcrumb-item">
              <i className="fa-solid fa-angles-right fs-8"></i>
            </li>
            <li className="breadcrumb-item active">Manage Corporate Order</li>
          </ol>
        </div>

        <div className="d-flex align-items-center justify-content-center gap-3 bg-gray-300 py-2 px-2 rounded">
          <div className="d-flex flex-column">
            <OverlayTrigger
              trigger="['hover','trigger']"
              placement="bottom"
              overlay={
                <Tooltip className="toltip-popover">
                  <span className="fs-8 text-white fw-semibold">{cateringIdDisplay || '-'}</span>
                </Tooltip>
              }
            >
              <label className="text-danger font-w500 fs-5 text-truncate w-150px">
                {cateringIdDisplay || '-'}
              </label>
            </OverlayTrigger>

            <OverlayTrigger
              trigger="['hover','trigger']"
              placement="bottom"
              overlay={
                <Tooltip className="toltip-popover">
                  <span className="fs-8 text-white fw-semibold">{formatDate(orderDate)}</span>
                </Tooltip>
              }
            >
              <label className="text-black font-w400 fs-7">{formatDate(orderDate)}</label>
            </OverlayTrigger>
          </div>
        </div>
      </div>

      {/* Part 2: Customer Info & Ordered Items */}
      <div className="row mb-4">
        <div
          className="col-lg-3 col-md-4 col-sm-2 mb-2 px-4 py-4 rounded mx-4"
          style={{ border: '1px solid #bebebeff' }}
        >
          <div className="row">
            {/* Customer Info Fields */}
            {[
              { label: 'Customer Name', value: customerInfo.customer_name },
              { label: 'Customer Mobile No', value: customerInfo.customer_number },
              { label: 'Company Name', value: customerInfo.company_name },
              { label: 'Company Mobilr No', value: customerInfo.company_number },
              { label: 'Head Count', value: <Badge bg="primary" className="text-white fs-6 px-3 py-0">{headCount}</Badge> },
              { label: 'Start Date', value: formatDate(order.order_date) },
              { label: 'End Date', value: order.end_date ? formatDate(order.end_date) : '-' },
              { label: 'Meals Period', value: getMealsPeriodLabel(order.meals_period) },
              { label: 'Total Cost', value: <span className="text-danger font-w600 fs-3 py-0">₹ {totalCost}</span> },
              {
                label: 'Order Status',
                value: (
                  <span
                    className="py-1 px-2 rounded font-w600 fs-7"
                    style={{
                      backgroundColor: orderStatus.bgColor || '#f3bc59',
                      color: orderStatus.textColor,
                    }}
                  >
                    {orderStatus.label}
                  </span>
                ),
              },
              { label: 'Special Request', value: specialRequest || '-' },
              { label: 'Order Postponed Date', value: orderPostponedDate || '-' },
              { label: 'Order Postponed / Cancelled Reason', value: combinedReason || '-' },
            ].filter(({ value }) => value !== '-').map(({ label, value }, idx) => (
              <div key={idx} className="col-lg-12 col-md-12 col-sm-12 d-flex flex-column mb-3">
                <label className="text-black text-start font-w600 fs-7">{label}</label>
                <div className="d-block">
                  {typeof value === 'string' || typeof value === 'number' ? (
                    <label className="text-success font-w600 fs-6 py-0">{value}</label>
                  ) : (
                    value
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Ordered Items Table */}
        <div className="col-lg-8 mb-2">
          <div className="row">
            <div className="col-lg-12 mb-2 d-flex align-items-center justify-content-start gap-2">
              <label className="text-red font-w600 fs-4 mb-2">Ordered Items</label>
              <span className="me-2 ms-2">-</span>
              <span className="text-black">
                <OverlayTrigger
                  overlay={
                    <Tooltip className="toltip-popover">
                      <span className="fs-8 text-white fw-semibold">No Of Items Ordered</span>
                    </Tooltip>
                  }
                >
                  <Badge bg="warning" className="text-white fs-5 py-0 px-2 me-1">
                    {items.length}
                  </Badge>
                </OverlayTrigger>
              </span>
            </div>

            <div className="row mb-4">
              <div className="col-lg-12">
                <div className="row scroll-y mh-550px">
                  <div className="col-lg-12 mb-3">
                    <table
                      ref={tableRef}
                      id="kt_datatable_responsive_approved"
                      className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
                    >
                      <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                          <th className="min-w-100px fs-5">Items</th>
                          <th className="min-w-80px text-center fs-5">Quantity / Units</th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-600 fw-semibold fs-7 text-center">
                        {items.length > 0 ? (
                          items.map(({ name, sub_category, quantity, unit_name, quantity_unit }, idx) => (
                            <tr key={idx}>
                              <td>
                                <div className="d-flex flex-column align-items-start justify-content-center">
                                  <label className="text-black font-w600 fs-7">{name}</label>
                                  <label className="text-success font-w600 fs-7">{sub_category}</label> {/* green */}
                                </div>
                              </td>
                              {/* <td>
                                <label className="text-black font-w600 fs-7">{quantity} {unit_name ? unit_name : 'No'}</label>
                              </td> */}
                             <td>
                                <label className="text-black font-w600 fs-7">
                                  {(() => {
                                    let displayQty = quantity; // <-- use current item
                                    let unitSlug = '';

                                    if ([1, 2].includes(quantity_unit)) {
                                      displayQty = quantity / 1000;
                                      unitSlug = 'kgs';
                                    } else if ([3, 4].includes(quantity_unit)) {
                                      displayQty = quantity / 1000;
                                      unitSlug = 'ltrs';
                                    } else if (quantity_unit === 15) {
                                      displayQty = quantity;
                                      unitSlug = "no's";
                                    } else {
                                      displayQty = quantity;
                                      unitSlug = unit_name || '';
                                    }

                                    // only call toFixed if displayQty is a valid number
                                    if (!isNaN(displayQty)) {
                                      displayQty = parseFloat(displayQty.toFixed(3));
                                    }

                                    return `${displayQty} ${unitSlug}`;
                                  })()}
                                </label>
                              </td>


                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={2}>No items ordered</td>
                          </tr>
                        )}
                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Part 3: Add-Ons and Payment Items */}
      <div className="row mb-4">
        {/* Add-On Services Section */}
        <div
          className="col-lg-3 col-md-4 col-sm-2 mb-2 px-4 py-4 rounded mx-4"
          style={{ border: '1px solid #bebebeff' }}
        >
          <div className="row">
            <label className="text-red font-w600 text-center fs-4 mb-2">Add-On Services</label>
            <div>
              <ul style={styles.ul}>
                {mappedAddOns.length > 0 ? (
                  mappedAddOns.map(({ name, vendor, units, costPerUnit, totalCost }, idx) => (
                    <li key={idx} style={styles.li}>
                      <div className="d-flex flex-row align-items-center justify-content-start gap-1">
                        <span style={{ ...styles.bullet, content: undefined }}>&#10148;</span>
                        <div className="d-flex flex-column align-items-start justify-content-between gap-1">
                          <label className="font-w600 text-black fs-7">{name}</label>
                          {vendor && <span className="font-w600 text-dark fs-7"> {vendor}</span>}
                        </div>
                      </div>
                      <div className="d-block mt-1">
                        <div className="d-flex flex-row align-items-center justify-content-between gap-1">
                          <div className="d-flex flex-column align-items-center justify-content-between gap-1">
                            <label className="font-w600 text-primary fs-7">Units</label>
                            <label className="font-w600 text-black fs-7">{units}</label>
                          </div>
                          <div className="d-flex flex-column align-items-center justify-content-between gap-1">
                            <label className="font-w600 text-primary fs-7">Cost (per Unit)</label>
                            <label className="font-w600 text-black fs-7">₹ {costPerUnit}-/</label>
                          </div>
                          <div className="d-flex flex-column align-items-center justify-content-between gap-1">
                            <label className="font-w600 text-primary fs-7">Total Cost</label>
                            <label className="font-w600 text-black fs-7">₹ {totalCost}-/</label>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))
                ) : (
                  <li style={{ fontStyle: 'italic', color: '#666' }}>No add-ons available.</li>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/* Payment Items Section (Static as requested) */}
        <div className="col-lg-8 mb-2">
          <div className="row">
            <div className="col-lg-12 mb-2">
              <label className="text-red font-w600 fs-4 mb-2">Payment Items</label>
            </div>

            <div className="row mb-4">
              <div className="col-lg-3">
                <div className="d-flex flex-column mb-3">
                  <label className="text-black text-start font-w600 fs-7">Payment Closing Date</label>
                  <div className="d-block">
                    <label className="text-primary font-w600 fs-6 py-0">
                      {formatDate(order?.payment_closing_date) || '-'}
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="d-flex flex-column mb-3">
                  <label className="text-black text-start font-w600 fs-7">Advance Amount</label>
                  <div className="d-block">
                    <label className="text-primary font-w600 fs-6 py-0">
                      ₹ {order.advance_amount || 0} /-
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="d-flex flex-column mb-3">
                  <label className="text-black text-start font-w600 fs-7">Discount Amount</label>
                  <div className="d-block">
                    <label className="text-primary font-w600 fs-6 py-0">
                      ₹ {order?.couponamount || 0} /-
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="d-flex flex-column mb-3">
                  <label className="text-black text-start font-w600 fs-7">GST</label>
                  <div className="d-block">
                    <label className="text-primary font-w600 fs-6 py-0">
                      {gst_percentage} % (₹ {order?.gst || 0}) /-
                    </label>
                  </div>
                </div>
              </div>
            </div>


            <div className="col-lg-12">
              <div className="row scroll-y mh-450px">
                <div className="col-lg-12 mb-3">
                  <table
                    ref={tableRef}
                    id="kt_datatable_responsive_approved"
                    className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
                  >
                    <thead>
                      <tr className="text-muted fw-bold fs-6 gs-0 th_head">
                        <th className="min-w-100px">Payment Amount</th>
                        <th className="min-w-100px">Scheduled Date</th>
                        <th className="min-w-80px">Payment Date</th>
                        <th className="min-w-80px">Status</th>
                      </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                      {payments?.length > 0 ? (
                        payments.map(({ amount, payment_schedule_date, initialPayDate, status }, idx) => (
                          <tr key={idx}>
                            <td>
                              <label className="text-black font-w600 fs-7">₹ {amount} /-</label>
                            </td>
                            <td>
                              <label className="text-black font-w600 fs-7"> {formatDate(payment_schedule_date)}</label>
                            </td>
                            <td>
                              <label className="text-black font-w600 fs-7">
                                {initialPayDate ? formatDate(initialPayDate) : '-'}
                              </label>
                            </td>
                            <td className='text-center'>
                              <label
                                className={`py-1 px-2 rounded font-w600 fs-7 ${status === 1
                                  ? 'bg-primary text-white'       // Paid
                                  : status === 0
                                    ? 'bg-danger text-white'        // Payment Pending
                                    : status === 2
                                      ? 'bg-warning text-black'       // Verification Pending (yellow bg, black text)
                                      : status === 3
                                        ? 'bg-secondary text-white'     // Cancelled
                                        : 'bg-light text-dark'           // Unknown
                                  }`}
                              >
                                {status === 0
                                  ? 'Payment Pending'
                                  : status === 1
                                    ? 'Paid'
                                    : status === 2
                                      ? 'Verification Pending'
                                      : status === 3
                                        ? 'Cancelled'
                                        : 'Unknown'}
                              </label>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center text-muted">
                            No payments found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )

}
export default ViewCorporateOrder;